var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"slide","appear":""},on:{"after-enter":function($event){return _vm.$emit('transition:after-enter', $event)}}},[_c(_setup.OzOverlay,{attrs:{"role":"dialog","should-fade-in":false,"z-index-class":_vm.zIndexClass,"dark-mode":_vm.darkMode,"position":_vm.position},on:{"scrim-click":function($event){return _vm.$emit('scrim-click')},"scrim-esc":function($event){return _vm.$emit('scrim-esc')}}},[_c('div',{class:[
        'modal-container',
        // Slide direction
        {
          'start-to-end': _vm.slideDirection === _setup.OzSideModalSlideDirection.StartToEnd,
          'end-to-start': _vm.slideDirection === _setup.OzSideModalSlideDirection.EndToStart,
        },
        // Positioning
        _vm.position === 'fixed' ? 'fixed' : 'absolute',
        'inset-y-0',
        // Position after sliding
        {
          'start-0': _vm.slideDirection === _setup.OzSideModalSlideDirection.StartToEnd,
          'end-0': _vm.slideDirection === _setup.OzSideModalSlideDirection.EndToStart,
        },
        // Layout
        _vm.widthClass,
        'flex',
        'flex-col',
        'overflow-hidden',
        _vm.topInnerCornerRadius === 12 && {
          'rounded-se-xl': _vm.slideDirection === _setup.OzSideModalSlideDirection.StartToEnd,
          'rounded-ss-xl': _vm.slideDirection === _setup.OzSideModalSlideDirection.EndToStart,
        },
        ,
        // Shadow
        'shadow-elevation-3',
        // Background
        {
          'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
          'bg-light-ui-100': _vm.darkMode === false,
          'bg-dark-ui-100': _vm.darkMode === true,
        },
      ]},[(_vm.$slots.header)?_c('div',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:_setup.scrollbarStyles},[_vm._t("body")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }